<h2 mat-dialog-title class="text-lg font-bold mb-1">Visualizar Logs - {{ data.documentIdentifier }}</h2>
<mat-dialog-content class="modal-content">
  <div class="p-2">
    <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceDetail" (matSortChange)="changeSort($event)" matSort>
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Mensaje</th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left">
          {{detail?.message}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Fecha<br>Creación</th>
        <td mat-cell *matCellDef="let element" class="px-6 text-left">{{ formatDate(element.createdAt, true) }}</td>
      </ng-container>

      <ng-container matColumnDef="dataSentHeader">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left"><span style="padding-left: 5px;">Enviada<br>(Cabecera)</span></th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left">
          <button mat-button color="primary" 
              (click)="loadDataHeader(detail, 'dataSent')">
            <mat-icon svgIcon="heroicons_solid:chat-bubble-left-ellipsis"></mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="dataRecievedHeader">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left"><span style="padding-left: 5px;">Recibida<br>(Cabecera)</span></th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left">
          <button mat-button color="primary" 
              (click)="loadDataHeader(detail, 'dataReceived')">
            <mat-icon svgIcon="heroicons_solid:chat-bubble-left-ellipsis"></mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="dataSent">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left"><span style="padding-left: 5px;">Enviada</span></th>
          <td mat-cell *matCellDef="let detail" class="px-6 text-left">
            <button mat-button color="primary" 
                [disabled]="!detail.dataSent" 
                (click)="detail.dataSent && openLogDetailDataModal(detail.dataSent)">
              <mat-icon svgIcon="heroicons_solid:chat-bubble-left-ellipsis"></mat-icon>
            </button>
          </td>
      </ng-container>

      <ng-container matColumnDef="dataRecieved">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left"><span style="padding-left: 5px;">Recibida</span></th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left">
          <button mat-button color="primary" 
              [disabled]="!detail.dataReceived" 
              (click)="detail.dataReceived && openLogDetailDataModal(detail.dataReceived)">
            <mat-icon svgIcon="heroicons_solid:chat-bubble-left-ellipsis"></mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
        <td mat-cell *matCellDef="let detail" class="px-6 text-left">
          <mat-icon svgIcon="heroicons_solid:check-circle" style="color: #15757d" *ngIf="detail.status == logStatusEnum.SUCCESS"></mat-icon>
          <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #b19527;" *ngIf="detail.status == logStatusEnum.IN_PROGRESS"></mat-icon>
          <mat-icon svgIcon="heroicons_solid:minus-circle" style="color: #ffa800" *ngIf="detail.status == logStatusEnum.WARNING"></mat-icon>
          <mat-icon svgIcon="heroicons_solid:x-circle" style="color: red" *ngIf="detail.status == logStatusEnum.ERROR"></mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100 dark:bg-gray-900"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail;" class="border-b"></tr>
    </table>
  </div>
  <div *ngIf="this.dataSourceDetail.data.length === 0" class="p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
  </div>
  <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalDetailItems"
      [pageSize]="pageSizeDetail" (page)="onPageChange($event)"></mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>